import React from "react";

export default function AttachmentModal({ file, onClose }) {
  if (!file) return null;

  const isImage = file.type?.startsWith("image");

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-4 max-w-3xl max-h-[90vh] overflow-auto shadow-xl relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-black text-xl"
        >
          ✕
        </button>

        {isImage ? (
          <img src={file.url} alt={file.name} className="max-w-full rounded" />
        ) : (
          <div className="p-6 text-center">
            <a
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline text-lg"
            >
              📄 Open File: {file.name}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}